import { Provider } from '@angular/core';

/**
 * Providers for the E2E auth bypass: none.
 *
 * The `e2e` build configuration in angular.json swaps this file for
 * auth-bypass.providers.e2e.ts. Every other build compiles this one, so the bypass is
 * never in a deployed bundle. See the README beside this file.
 */
export const authBypassProviders: Provider[] = [];
